
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    HeaderImage
  }
})
export default class HeaderGroup extends Vue {
  @Prop({ default: () => [] }) memberIds: string[]
  @Prop({ default: 26 }) size: number

  get members() {
    return this.memberIds.slice(0, 3)
  }

  get groupStyle() {
    const AVATAR_OVERLAP = 10
    const len = this.members.length

    if (len > 1) {
      const totalWidth = this.size * len - AVATAR_OVERLAP * (len - 1)
      return { width: `${totalWidth}px`, '--avatar-overlap': `${AVATAR_OVERLAP}px` }
    } else if (len === 1) {
      return { width: `${this.size}px`, '--avatar-overlap': `${AVATAR_OVERLAP}px` }
    }
    return { '--avatar-overlap': `${AVATAR_OVERLAP}px` }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
